// extracted by mini-css-extract-plugin
module.exports = {"blocks":"BeautyCampaignBlocks_blocks__eOVlC","card":"BeautyCampaignBlocks_card__mpR6K","site":"BeautyCampaignBlocks_site__eeot6"};